import { formatUptime, useServerStatus } from '../hooks/useServerStatus';

export function Header() {
    const status = useServerStatus();
    const state = status.online === null ? 'unknown' : status.online ? 'online' : 'offline';
    const label = status.online === null ? 'Checking' : status.online ? 'Live' : 'Status unavailable';
    const detail = status.online ? `${status.version ? ` · v${status.version}` : ''}${status.uptimeSec ? ` · up ${formatUptime(status.uptimeSec)}` : ''}` : '';

    return (
        <header className="tkh-header">
            <div className="tkh-wrap">
                <a href="/" className="tkh-brand" aria-label="Turkish Airlines MCP Server home">
                    <img src="/assets/logo.png" alt="Turkish Airlines" />
                    <span className="tkh-brand-name">MCP Server</span>
                </a>
                <nav className="tkh-nav" aria-label="Sections">
                    <a href="#how">How it works</a>
                    <a href="#tools">Tools</a>
                    <a href="#connect">Connect</a>
                    <a href="#trust">Security</a>
                </nav>
                <div className="tkh-status" data-state={state} role="status" aria-live="polite">
                    <i aria-hidden="true" />
                    {label}
                    {detail && <span className="detail">{detail}</span>}
                </div>
            </div>
        </header>
    );
}
